import { css } from '@emotion/react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import DiscoveryShelf from 'dashboard/components/discovery-shelf';
import OfferingCardsResponsiveListing from 'dashboard/components/offering-cards-responsive-listing';
import { fetchRecommendedOfferings } from 'redux/actions/courses';
import { getRecommendedOfferings } from 'redux/selectors/course';
import { useAppDispatch } from 'redux/store';
import {
  doubleSpacing,
  halfSpacing,
  standardSpacing,
} from 'styles/global_defaults/scaffolding';
import {
  screenSmMax,
  screenSmMin,
} from 'styles/global_defaults/media-queries';

type Props = {
  institutionId: number;
  surface: 'catalog' | 'dashboard';
};

const styles = css`
  margin: 0 auto ${doubleSpacing}px;
`;

const RecommendForYou = ({ institutionId, surface }: Props) => {
  const dispatch = useAppDispatch();
  const { offerings } = useSelector(getRecommendedOfferings);
  const isTablet = useMediaQuery({
    query: `(min-width: ${screenSmMin}px) and (max-width: ${screenSmMax}px)`,
  });

  useEffect(() => {
    if (institutionId) {
      dispatch(fetchRecommendedOfferings({ institutionId }));
    }
  }, [dispatch, institutionId]);

  if (!offerings.length) return null;

  const sectionDataQa = surface === 'dashboard'
    ? config.pendo.learningCatalog.recommendForYouDashboard
    : config.pendo.learningCatalog.recommendForYouCatalog;
  const titleId = `recommend-for-you-${surface}`;

  return (
    <DiscoveryShelf
      className='recommend-for-you flex-shrink-0'
      title={t.DASHBOARD.RECOMMEND_FOR_YOU()}
      titleId={titleId}
      dataQa={sectionDataQa}
      css={styles}
    >
      <OfferingCardsResponsiveListing
        offerings={offerings}
        className='offering-cards d-flex justify-content-center'
        spaceBetweenCards={isTablet ? halfSpacing : standardSpacing}
        offeringCardStyle={{ marginBottom: 0 }}
        openInNewTab
        dataQa={config.pendo.learningCatalog.recommendedCourse}
        dataQaId={(offering, index) => (
          `${surface}_${index + 1}_${offering.id}`
        )}
      />
    </DiscoveryShelf>
  );
};

export default RecommendForYou;
